module.exports = {
        srcSet: __webpack_public_path__ + "0c5f7089bfdaf756-71.webp"+" 71w",
        images: [{path: __webpack_public_path__ + "0c5f7089bfdaf756-71.webp",width: 71,height: 40}],
        src: __webpack_public_path__ + "0c5f7089bfdaf756-71.webp",
        toString: function(){return __webpack_public_path__ + "0c5f7089bfdaf756-71.webp"},
        
        width: 71,
        height: 40
      }